import * as React from "react";
import {
  Alert,
  Box,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { PendingPaymentType } from "../../types/entitiesModel";
import { AuthContext } from "../../context/AuthContext";

const PendingPayments: React.FC = () => {
  const { token } = React.useContext(AuthContext) || {};
  const [pendingPayments, setPendingPayments] = React.useState<
    PendingPaymentType[]
  >([]);
  const [error, setError] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        let options = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };

        const response = await fetch(`api/invoices/pendingpayments`, options);

        if (!response.ok) {
          throw new Error("Error al obtener los datos de la API");
        }

        const data = await response.json();
        setPendingPayments(data.data);
      } catch (error: unknown) {
        setError((error as Error).message);
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      fetchData();
    }
  }, [token]);

  return (
    <>
      {!loading ? (
        <Box>
          {error ? <Alert severity="error">{error}</Alert> : <></>}
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h3">
                Pagos pendientes por revisión
              </Typography>
              <Box
                sx={{
                  height: "400px",
                  overflowY: "auto",
                  overflowX: "auto",
                }}
              >
                <Table
                  aria-label="simple table"
                  sx={{
                    mt: 3,
                    whiteSpace: "nowrap",
                    minWidth: "600px", 
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <Typography color="textSecondary" variant="h6">
                          Document
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography color="textSecondary" variant="h6">
                          Nombre
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography color="textSecondary" variant="h6">
                          Estado
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography color="textSecondary" variant="h6">
                          Monto
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {pendingPayments.map(
                      (pay: PendingPaymentType, key: number) => (
                        <TableRow key={key}>
                          <TableCell>
                            <Typography
                              sx={{ fontSize: "15px", fontWeight: "500" }}
                            >
                              {pay.document}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Typography
                                variant="h6"
                                sx={{ fontWeight: "600" }}
                              >
                                {pay.name}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Chip
                              sx={{
                                pl: "4px",
                                pr: "4px",
                                backgroundColor: "#42d896",
                                color: "white",
                                fontWeight: "bold",
                              }}
                              size="small"
                              label={pay.status}
                            />
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Typography
                                variant="h6"
                                sx={{ fontWeight: "600" }}
                              >
                                {pay.amount}
                              </Typography>
                            </Box>
                          </TableCell>
                        </TableRow>
                      )
                    )}
                  </TableBody>
                </Table>
              </Box>
            </CardContent>
          </Card>
        </Box>
      ) : (
        <CircularProgress />
      )}
    </>
  );
};

export default PendingPayments;
